define([
    "jquery",
    "underscore",
    "marionette",
    "swiper",
    "views/common/callback_view"
], function ($, _, Marionette, Swiper, CallbackView) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'popupModal': '.emergency_common_modal',
            'popupCloseForDay': '.close_for_day ',
        },

        initialize: function () {
            if (window.lang == 'ja_JP') {
                new CallbackView();
            }
            new Swiper('.swiper-container', {
                slidesPerView: 7,
                initialSlide: 7,
                noSwiping: true,
                autoplayDisableOnInteraction: false,
                loop: true,
                autoHeight: true,
                autoplay: 1500
            });

            let that = this;
            $(window).on('load', function () {
                that.showPopups();
            });

            if ( window.location !== window.parent.location ) {
                console.log("iframe");
                $("#header_layout").hide();
                $("#footer_layout").hide();
                $("#side_bar_wrapper").hide();
                $(".copy-trading-floating-button").hide();
                $(".copy-trading-mobile-floating-button").hide();
                // Very temporary !!!!
                $("#deposit_link_iframe").attr("target", "_blank");
            }
        },

        showPopups: function () {
            var that = this;
            $(this.ui.popupModal).each(function () {
                $(this).modal({
                    closeExisting: false,
                    closeOnEscape: false,
                    clickClose: false,
                    showClose: false
                });
            })

            $(this.ui.popupCloseForDay).click(element => {
                let id = element.target.dataset.id;
                if (id) {
                    that.confirmForTheDay(id);
                }
            })
        },

        confirmForTheDay: function (name) {
            $.ajax('/rest_popup/confirm_popup_for_day', {
                method: "POST",
                data: {
                    'popup_name': name
                },
                success: function (data) {
                }
            })
        }
    });
});